module.exports = __webpack_public_path__ + "assets/images/profile_pic_3.0b8ecfa7.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@int/signature/assets/images/profile_pic_3.png
// module id = 1141
// module chunks = 0